import { useMemo } from 'react'

import { TeamRole } from '@/consts/team'
import { TeamFSContext } from '@/pages/data-mgr/core/context'
import { useDownloadCore } from '@/pages/data-mgr/core/hooks/useDownload'

/**
 * Team version of useDownload hook
 * Uses TeamFSContext with useDownloadCore for team datadrive downloads
 */
export function useTeamDownload(userRole: TeamRole, teamId: number) {
  const context = useMemo(() => new TeamFSContext(userRole, teamId), [userRole, teamId])
  return useDownloadCore(context)
}
